const VIDEO_ASSOCIATIONS_REQUEST = "videoAssociations/REQUEST";
const VIDEO_ASSOCIATIONS_SUCCESS = "videoAssociations/SUCCESS";
const VIDEO_ASSOCIATIONS_FAILURE = "videoAssociations/FAILURE";
const VIDEO_ASSOCIATIONS_RESET = "videoAssociations/RESET";
const UPDATED_DROPBOX_DATA = "UPDATED_DROPBOX_DATA";
const UPDATED_API_DATA = "UPDATED_API_DATA";
const SET_VIDEO_TRANSCRIPT = "SET_VIDEO_TRANSCRIPT/RESET";

export default {
  VIDEO_ASSOCIATIONS_REQUEST,
  VIDEO_ASSOCIATIONS_SUCCESS,
  VIDEO_ASSOCIATIONS_FAILURE,
  VIDEO_ASSOCIATIONS_RESET,
  UPDATED_DROPBOX_DATA,
  UPDATED_API_DATA,
  SET_VIDEO_TRANSCRIPT,
};
